import { render, staticRenderFns } from "./RevenueMetricConfigurationPage.vue?vue&type=template&id=4d487a78"
import script from "./RevenueMetricConfigurationPage.vue?vue&type=script&lang=ts"
export * from "./RevenueMetricConfigurationPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports